<template>
  <div class="container-main-cdb">
    <div class="section-media-cdb">
      <div class="text-introductory-cdb">
        <p>Respeitável público,</p>
        <p>Aqui você encontra os circos instalados na sua cidade ou próximas, onde sua familía pode curtir um divertimento sadio e inesquecível: palhaços, malabaristas, acrobatas, trapezistas, mágicos, bailarinas e shows diversos. Veja o caso do Erik no vídeo ao lado.</p>
      </div>
      <div class="video-introductory-cdb">
        <video controls poster="./assets/logo_circos_do_brasil.png" class="video-cdb">
          <source src="./assets/video_circos_do_brasil.mp4" type="video/mp4">
          <object>
            <embed src="./assets/video_circos_do_brasil.mp4" type="application/x-shockwave-flash" 
            allowfullscreen="false" allowscriptaccess="always">  		
          </object>
          Formato não suportado  
        </video>
      </div>
    </div>
    <div class="found-circos" :style="{'background': researched.circo.length > 0 || researched.school.length > 0 ? '#eba943' : 'transparent'}">
      <div class="found-title-cdb" v-if="researched.length > 0">
        <h2 class="h2-title-cdb">CIRCOS ENCONTRADOS</h2>
        <p class="p-title-cdb">Encontramos {{ researched.length }} circos próximos à você</p>
      </div>
      <div class="list-found-items" v-if="researched.circo.length > 0 || researched.school.length > 0">
        <div class="tab-list-items" v-if="researched.circo.length > 0 && researched.school.length > 0">
          <button class="btn-found-circo" @click="typeFoundSelected = 'circo'" :style="{'border': typeFoundSelected === 'circo' ? '2px solid #bf3d26' : 'none', 'color': typeFoundSelected === 'circo' ? '#bf3d26' : 'gray' }">CIRCO</button>
          <button class="btn-found-school" @click="typeFoundSelected = 'school'" :style="{'border': typeFoundSelected === 'school' ? '2px solid #bf3d26' : 'none', 'color': typeFoundSelected === 'school' ? '#bf3d26' : 'gray' }">CIRCO ESCOLA</button>
        </div>
        <div class="item-found-circo" v-if="typeFoundSelected === 'circo'">
          <div class="item-found" v-for="(item, idx) in researched.circo" :key="idx">
            <div class="info-item-cdb">
              <p class="item-found-name" @click="openModalContact()">{{ item.nome }}</p>
              <p class="item-found-address">{{ item.localizacao || item.endereco }}</p>
              <p class="item-found-phone-site">{{ item.telefone_equipamento }} | {{ item.site }}</p>
            </div>
            <div class="item-found-purchase">
              <div class="buy-tickets-cdb">
                <button class="body-tickets" v-if="item.link_ingresso_fisico"><a class="link-ticket-cdb" :href="item.link_ingresso_fisico" target="_blank">INGRESSOS BILHETERIA</a></button>
                <button class="online-tickets" v-if="item.link_ingresso_online"><a class="link-ticket-cdb" :href="item.link_ingresso_online" target="_blank">INGRESSOS ONLINE</a></button>
              </div>
              <button class="know-more-cdb" @click="goEvent(item)">
                <p class="know-more-label">SAIBA MAIS</p>
                <span class="material-symbols-outlined know-more-icon">arrow_forward</span>
              </button>
            </div>
          </div>
        </div>
        <div class="item-found-school" v-if="typeFoundSelected === 'school'">
          <div class="item-found" v-for="(item, idx) in researched.school" :key="idx">
            <div class="info-item-cdb">
              <p class="item-found-name" @click="openModalContact()">{{ item.nome }}</p>
              <p class="item-found-address">{{ item.localizacao || item.endereco }}</p>
              <p class="item-found-phone-site">{{ item.telefone_equipamento }} | {{ item.site }}</p>
            </div>
            <div class="item-found-purchase">
              <div class="buy-tickets-cdb">
                <button class="body-tickets" v-if="item.link_ingresso_fisico"><a class="link-ticket-cdb" :href="item.link_ingresso_fisico" target="_blank">INGRESSOS FÍSICOS</a></button>
                <button class="online-tickets" v-if="item.link_ingresso_online"><a class="link-ticket-cdb" :href="item.link_ingresso_online" target="_blank">INGRESSO ONLINE</a></button>
              </div>
              <button class="know-more-cdb" @click="goEvent(item)">
                <p class="know-more-label">SAIBA MAIS</p>
                <span class="material-symbols-outlined know-more-icon">arrow_forward</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="search-cdb">
        <div class="content-search-cdb">
          <p class="title-search-cdb">INFORME A SUA CIDADE E VEJA OS CIRCOS QUE ESTÃO INSTALADOS NA REGIÃO.</p>
          <label for="search-circo" class="label-search-circo-cdb">
            <span class="title-label-cdb">Minha cidade:</span>
              <v-select
                class="search-circo-uf-cdb"
                :options="optionsStates"
                label="uf"
                placeholder="UF"
                :reduce="name => name.uf"
                v-model="searchCircoInCity.uf"
                @input="searchState(searchCircoInCity.uf)"
              >
              </v-select>
              <v-select
                class="search-circo-cdb"
                :disabled="!showSearchInputCity"
                :options="searchCircoInCity.allCitysOptions"
                label="city"
                placeholder="Cidade"
                v-model="searchCircoInCity.searchCitySelected"
              >
              </v-select>
            <button class="confirm-search-cdb" :disabled="!showSearchInputCity" @click="searchCircoWithCity()">Buscar</button>
          </label>
        </div>
        <div class="star-icons-circos-cdb">
          <span class="material-symbols-outlined star-icon-small">star</span>
          <span class="material-symbols-outlined star-icon-large">star</span>
          <span class="material-symbols-outlined star-icon-small">star</span>
        </div>
      </div>
    </div>
    <div class="indicate-circo-cdb">
      <div class="indicate-cdb">
        <div class="indicate-labels">
          <h2 class="indicate-title">INDIQUE UM CIRCO</h2>
          <p class="indicate-text">Se vc sabe de algum ou outro circo instalado na sua cidade e que não consta no CIRCOS DO BRASIL, favor <span style="font-weight: bold">informar os dados ao lado</span> e o circo e a sua cidade serão incluídos no site.</p>
        </div>
        <div class="indicate-fields-cdb">
          <label for="city-state" class="label-cdb">
            <p>Estado/Cidade</p>
            <div class="city-state-select">
              <v-select
                class="input-state-cdb"
                :options="optionsStates"
                label="uf"
                placeholder="UF"
                :reduce="name => name.uf"
                v-model="formContact.uf"
                @input="setState(formContact.uf)"
              >
              </v-select>
              <v-select
                class="input-city-cdb"
                :options="optionsCitys"
                :disabled="!showInputCity"
                label="city"
                placeholder="Cidade"
                :reduce="name => name.city"
                v-model="formContact.cidade"
              >
              </v-select>
            </div>
          </label>
          <label for="circo-nameCirco" class="label-cdb">
            <p>Nome do circo *</p>
            <input type="text" v-model="formContact.nameCirco"  id="circo-nameCirco">
          </label>
          <label for="circo-name" class="label-cdb">
            <p>Seu nome *</p>
            <input type="text" v-model="formContact.name"  id="circo-name">
          </label>
          <label for="phone-cdb"  class="label-cdb">
            <p>Seu celular *</p>
            <input type="text" v-model="formContact.phone"  id="phone-cdb">
          </label>
          <label for="email-cdb" class="label-cdb">
            <p>Seu e-mail *</p>
            <input type="text" v-model="formContact.email"  id="email-cdb">
          </label>
          <button @click="sendIndique" class="indicate-send-btn">ENVIAR</button>
        </div>
      </div>
      <div class="advertence-cdb">
          <p class="advertence-title">DONOS E RESPONSÀVEIS PELOS CIRCOS</p>
          <p class="advertence-label">Este site só tem o objetivo de divulgar a localização do seu circo. Se ele nao consta neste site você podera inclui-lo no "Indique um circo" e entraremos em contato para cadastra-lo.</p>
          <p class="advertence-title">ATENÇÂO</p>
          <p class="advertence-label">Mantenha a sua <span style="cursor: pointer; text-decoration: underline;" @click="goSearch()">localização</span> sempre atualizada.</p>
      </div>
    </div>
    <detail-event />
  </div>
</template>

<script>
import { VueSelect } from "vue-select"
import { cdbService } from "@/components/common/services/cdb_service"
import DetailEvent from './components/DetailEvent.vue'
import { sendService} from "@/components/common/services/send"
import ModalErrorSearch from './components/ModalErrorSearch.vue'

export default {
  name: 'EventsCircos',
  props: [],
  components: {
    VueSelect,
    DetailEvent,
    ModalErrorSearch
  },
  data () {
    return {
      typeFoundSelected: 'circo',
      researched: {
        circo: [],
        school: []
      },
      optionsStates: [],
      stateSelected: null,
      optionsCitys: [],
      citySelected: null,
      showInputCity: false,
      showSearchInputCity: false,
      searchCircoInCity: {
        uf: '',
        allCitysOptions: [],
        searchCitySelected: ''
      },
      formContact: {
        nameCirco: '',
        name: '',
        email: '',
        cidade: '',
        phone: '',
        uf: ''
      }
    }
  },
  beforeDestroy () {
    this.$root.$off('open-detail-event')
    this.$root.$off('open-modal-contact')
    this.$root.$off('circos-researched')
  },
  async mounted () {
    const states = await cdbService.getState()

    this.optionsStates = states.map(state => { return { uf: state.sigla, name: state.nome } })
    this.optionsStates.sort((a, b) => {
      if(a.uf < b.uf) { return -1 }
      if(a.uf > b.uf) { return 1 }
    return 0
    })

    this.$root.$on('circos-researched', payload => {
      this.researched.circo = []
      this.researched.school = []
      payload.forEach(e => {
        if (e.tipo_equipamento.nome === 'CIRCOS') {
          this.researched.circo.push(e)
        }
        if (e.tipo_equipamento.nome === 'CIRCO ESCOLA') {
          this.researched.school.push(e)
        }
      })
      const elementDiv = document.querySelector('.found-circos')
      elementDiv.scrollIntoView()
    })
  },
  computed: {

  },
  methods: {
    goSearch () {
      this.$root.$emit('go-to-search')
    },
     async searchCircoWithCity () {
       if (this.searchCircoInCity.searchCitySelected.city.length > 0) {
        const result = await cdbService.searchCircoForCity(this.searchCircoInCity.searchCitySelected.city)
        if (result.length > 0) {
          this.researched.circo = []
          this.researched.school = []
          result.forEach(e => {
            if (e.tipo_equipamento.nome === 'CIRCOS') {
              this.researched.circo.push(e)
            }
            if (e.tipo_equipamento.nome === 'CIRCO ESCOLA') {
              this.researched.school.push(e)
            }
          })
        } else {
          this.$root.$emit('open-modal-error-search', true)
        }
        this.searchCircoInCity.searchCitySelected = ''
      }
    },
    goEvent (e) {
      this.$root.$emit('open-detail-event', e)
    },
    async setState (uf) {
      const citys = await cdbService.getCity(uf)
      this.optionsCitys = citys.map(c => { return { city: c.nome } })
      this.optionsCitys.length > 0 ? this.showInputCity = true : false
    },
    async searchState (uf) {
      const searchCitys = await cdbService.getCity(uf)
      this.searchCircoInCity.allCitysOptions = searchCitys.map(c => { return { city: c.nome } })
      this.searchCircoInCity.allCitysOptions.length > 0 ? this.showSearchInputCity = true : false
    },
    openModalContact () {
      this.$root.$emit('open-modal-contact', true)
    },
    sendIndique() {
      if(this.formContact.nameCirco == '' || this.formContact.email == '' || this.formContact.phone == '' || this.formContact.name == '') {
        this.$swal({
          title: "É necessário informar os dados obrigatórios com *",
          type: "error",
          showConfirmButton: true,
          timer: 4000,
        })
      } else {
        sendService.indiqueCirco(this.formContact).then(
          response => {
            this.formContact = {
              nameCirco: '',
              name: '',
              email: '',
              cidade: '',
              phone: '',
              uf: ''
            }
            this.$swal({
              title: "Sua solicitação de indicação foi enviada com sucesso, agradecemos o seu contato.",
              type: "success",
              showConfirmButton: false,
              timer: 4000,
            })
          },
          error => {
            this.$swal({
              title: "Ocorreu um erro, tente novamente",
              type: "error",
              showConfirmButton: false,
              timer: 4000,
            })
          }
        )
      }
    }
  }
}
</script>

<style lang="scss">
</style>